import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';

import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialModule } from '@app/material/material.module';

import { SelectModule } from '@shared/components/form/select/select.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { AnswerSetDialogComponent } from './answer-set-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    MaterialModule,
    SelectModule,
    InputModule,
    ButtonModule
  ],
  declarations: [AnswerSetDialogComponent],
  entryComponents: [AnswerSetDialogComponent]
})
export class AnswerSetDialogModule { }
